import React from 'react';
import AdmNivoChart from '../adm_executive_view/AdmNivoChart';
import { addSharpTransitions, createLineConfig } from './admChartUtils';

/**
 * Reusable component for rendering interval (non-cumulative) charts for ADM data
 * Supports arrival and/or closure data
 */
export default function AdmIntervalChartWrapper(props) {
  const {
    title,
    arrival,
    closure,
    evr,
    increment,
    prediction_horizon,
    d0_interval,
    d1_interval,
    d2_interval,
    arrivalColor,
    closureColor,
    chartHeight = '24vw',
    showArrival = true,
    showClosure = true,
    yMax,
  } = props;

  const parsedD2Interval = Number(d2_interval);
  const parsedPredictionHorizon = Number(prediction_horizon);

  const hasValidD2 = d2_interval !== null && d2_interval !== undefined && Number.isFinite(parsedD2Interval);

  const hasValidPredictionHorizon = prediction_horizon !== null && prediction_horizon !== undefined && Number.isFinite(parsedPredictionHorizon);

  const evrMaxInterval = hasValidD2 && hasValidPredictionHorizon ? parsedD2Interval + parsedPredictionHorizon: null;

  // Early return if no data
  if (!arrival && !closure && !evr) {
    return null;
  }

  const lines = [];
  //add EVR lines if requested
  if (evr) {
    // EVR Cumulative
    if (evr.cumulative && evr.cumulative.length > 0) {
      const cumulativeFiltered = evr.cumulative.filter(d =>d.value !== null &&d.value !== undefined &&Number.isFinite(Number(d.value))).filter(d =>!hasValidD2 ||Number(d.interval) <= parsedD2Interval);
      if (cumulativeFiltered.length > 0) {
        lines.push(createLineConfig('EVR (Cumulative)',cumulativeFiltered,arrivalColor,'solid',true));
      }
    }
    
    // EVR Rolling 4W
    if (evr.rolling_4w && evr.rolling_4w.length > 0) {
      const rollingFiltered = evr.rolling_4w.filter(d =>d.value !== null &&d.value !== undefined &&Number.isFinite(Number(d.value))).filter(d =>!hasValidD2 ||Number(d.interval) <= parsedD2Interval);
      if (rollingFiltered.length > 0) {
        lines.push(createLineConfig('EVR (Rolling 4W)',rollingFiltered,closureColor,'solid',true));
      }
    }

    //EVR Perdicted
    //if (evr.predicted && evr.predicted.length > 0) {
    //  const predictedFiltered = evr.predicted.filter(d => d.value !== null).filter(d => d.interval <= d2_interval);

    //  if (predictedFiltered.length > 0) {
    //    lines.push(createLineConfig('EVR (Predicted)',predictedFiltered,arrivalColor,'dashed',true));
    //  }
    //}
  }

  if (evr && evrMaxInterval != null) {
    const firstEvrInterval = Math.min(
      ...[
        ...(evr.cumulative || []),
        ...(evr.rolling_4w || []),
      ]
        .filter(point =>
          point.value !== null &&
          point.value !== undefined &&
          Number.isFinite(Number(point.value))
        )
        .map(point => Number(point.interval))
    );
    
    if (Number.isFinite(firstEvrInterval)) {
      lines.push({
        id: 'EVR Target',
        data: [
          {
            interval: firstEvrInterval,
            value: 1,
            date: null,
          },
          {
            interval: evrMaxInterval,
            value: 1,
            date: null,
          },
        ],
        color: 'black',
        strokeStyle: 'dashed',
        legend: false,
      });
    }
  }

  // Add Arrival lines if requested
  if (showArrival && arrival) {
    // Arrival Actual
    if (arrival.actual_processed && arrival.actual_processed.length > 0) {
      lines.push(createLineConfig('Arrival (Actual)', arrival.actual_processed, arrivalColor, 'solid', true));
    }

    // Arrival Predicted with sharp transitions
    if (arrival.predicted && arrival.predicted.length > 0) {
      lines.push(createLineConfig('Arrival (Predicted)', addSharpTransitions(arrival.predicted), arrivalColor, 'dashed', true));
    }
  }

  // Add Closure lines if requested
  if (showClosure && closure) {
    // Closure Actual
    if (closure.actual_processed && closure.actual_processed.length > 0) {
      lines.push(createLineConfig('Closure (Actual)', closure.actual_processed, closureColor, 'solid', true));
    }

    // Closure Predicted with sharp transitions
    if (closure.predicted && closure.predicted.length > 0) {
      lines.push(createLineConfig('Closure (Predicted)', addSharpTransitions(closure.predicted), closureColor, 'dashed', true));
    }
  }

  return (
    <AdmNivoChart
      title={title}
      lines={lines}
      rects={[]}
      scatters={[]}
      chartHeight={chartHeight}
      allowHidingLines={true}
      allowHoverTooltip={true}
      xAxisLabel={`Interval (${increment} days)`}
      increment={increment}
      d0_interval={d0_interval}
      d1_interval={d1_interval}
      d2_interval={d2_interval}
      maxIntervalOverride={evrMaxInterval}
      yMax={yMax}
    />
  );
}
